import React from "react";
import FAQAccordion from "./FAQAccordion";
import '../components/FAQSection.css'
const FAQSection = () => {
  const faqs = [
    {
      question: "What is your return policy?",
      answer: "While we do not accept returns, we do offer any support required with 24 hour response time for all queries.",
    },
    {
      question: "How do I track my purchase?",
      answer: "Your chats will automatically get credited to your account once the payment is confirmed. If you face any issues, you can write to vedicrashiofficial@gmail.com",
    },
    {
      question: "Do you offer discounts?",
      answer: "Yes, we offer different discounts from time to time",
    },
  ];

  return (
    <div className="faq-page">
      <h1>Frequently Asked Questions</h1>
      <p>Let us help answer the most common questions you might have.</p>
      <FAQAccordion faqs={faqs} />
    </div>
  );
};

export default FAQSection;
